// Build commands:
//   npm start              → dev server, staging API (uses .env.staging)
//   npm run build          → production build (uses .env.production → https://api.vavschool.com/)
//   npm run build:staging  → staging build    (uses .env.staging    → https://testapi.vavschool.com/)

const PRODUCTION_API = "https://api.vavschool.com/";
export const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? PRODUCTION_API;



function currentAcademicYear(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const startYear = m >= 3 ? y : y - 1;
  return `${startYear}-${String(startYear + 1).slice(2)}`;
}


export const API_URLS = {
  // Authentication
  LOGING:     `${BASE_URL}api/v1/auth/login`,
  VERIFY_OTP: `${BASE_URL}api/v1/auth/verify_otp`,
  LOGOUT:     `${BASE_URL}api/v1/auth/logout`,

  // Home screen
  STAT_CARDS_DATA_HOME_SCREEN: (teacher_id: number) =>
    `${BASE_URL}api/v1/attendance/teacher/dashboard?teacher_id=${teacher_id}`,

  // Teacher attendance
  GET_TEACHER_LIST: `${BASE_URL}api/v1/teachers/get`,
  GET_ATTENDANCE_TEACHER:  `${BASE_URL}api/v1/attendance/teacher/list`,
  MARK_ATTENDANCE_TEACHER: `${BASE_URL}api/v1/attendance/teacher/mark`,

  GET_ALL_TEACHER_ATTENDANCE: (date: string) =>
    `${BASE_URL}api/v1/attendance/teacher/all?date=${date}`,

  // Class / student attendance
  GET_CLASSES: (teacher_id: number) =>
    `${BASE_URL}api/v1/class_teacher_mappings/get/teacher/${teacher_id}`,
  GET_ALL_CLASSE_LIST_FOR_SUPERVISOR: `${BASE_URL}api/v1/class_fees/list`,
  GET_STUDENTS_LIST_CLASS_WISE: (classId: number, section_id: number) =>
    `${BASE_URL}api/v1/students/list?search=&class_id=${classId}&section_id=${section_id}`,
  GET_CLASS_ATTENDANCE:    `${BASE_URL}api/v1/attendance/student/list`,
  MARK_CLASS_ATTENDANCE:   `${BASE_URL}api/v1/attendance/student/mark_bulk`,
  UPDATE_CLASS_ATTENDANCE: (student_id: number, date: string) =>
    `${BASE_URL}api/v1/attendance/student/update/${student_id}?date=${date}`,

  GET_STUDENT_ACADEMIC_SUMMARY: (student_id: number, ) =>
    `${BASE_URL}api/v1/attendance/student/card/${student_id}`,

  // Student search (by name or UID, no class filter)
  GET_LIST_OF_STUDENT: (params?: { search?: string }) => {
    const query = new URLSearchParams();
    if (params?.search) query.append('search', params.search);
    const qs = query.toString();
    return `${BASE_URL}api/v1/students/list${qs ? `?${qs}` : ''}`;
  },

  // Fine & Complaint module
  GET_FINE_COMPLAINT_STATS: `${BASE_URL}api/v1/complaint_fines/stats`,

  GET_COMPLAINT_FINES_LIST: (params?: { student_name?: string; student_uid?: string; type?: string; status?: string }) => {
    const query = new URLSearchParams();
    if (params?.student_name) query.append('student_name', params.student_name);
    if (params?.student_uid)  query.append('student_uid',  params.student_uid);
    if (params?.type)         query.append('type',         params.type);
    if (params?.status)       query.append('status',       params.status);
    const qs = query.toString();
    return `${BASE_URL}api/v1/complaint_fines/get${qs ? `?${qs}` : ''}`;
  },

  GET_MY_CLASS_COMPLAINT_FINES: (params?: { student_name?: string; student_uid?: string; type?: string; status?: string }) => {
    const query = new URLSearchParams();
    if (params?.student_name) query.append('student_name', params.student_name);
    if (params?.student_uid)  query.append('student_uid',  params.student_uid);
    if (params?.type)         query.append('type',         params.type);
    if (params?.status)       query.append('status',       params.status);
    const qs = query.toString();
    return `${BASE_URL}api/v1/complaint_fines/my_class${qs ? `?${qs}` : ''}`;
  },

  GET_MY_RECORDS_COMPLAINT_FINES: (params?: { student_name?: string; student_uid?: string; type?: string; status?: string }) => {
    const query = new URLSearchParams();
    if (params?.student_name) query.append('student_name', params.student_name);
    if (params?.student_uid)  query.append('student_uid',  params.student_uid);
    if (params?.type)         query.append('type',         params.type);
    if (params?.status)       query.append('status',       params.status);
    const qs = query.toString();
    return `${BASE_URL}api/v1/complaint_fines/my_records${qs ? `?${qs}` : ''}`;
  },

  GET_COMPLAINT_FINE_BY_ID:  (id: number) => `${BASE_URL}api/v1/complaint_fines/get/${id}`,
  CREATE_COMPLAINT_FINE:     `${BASE_URL}api/v1/complaint_fines/create`,
  UPDATE_COMPLAINT_FINE:     (id: number) => `${BASE_URL}api/v1/complaint_fines/update/${id}`,

  // Insights
  GET_TEACHER_DETAILS:  (params: { teacher_id: number; academic_year: string; month?: number }) => {
  const query = new URLSearchParams();
  query.append('teacher_id', String(params.teacher_id));
  query.append('academic_year', params.academic_year);
  if (params.month !== undefined && params.month !== null) {
    query.append('month', String(params.month));  
  }
  return `${BASE_URL}api/v1/attendance/teacher/monthly_summary?${query.toString()}`;
  },
  GET_STUDENT_DETAILS: (classId: number, sectionId: number, academicYear: string = currentAcademicYear()) =>
    `${BASE_URL}api/v1/attendance/student/monthly_summary?class_id=${classId}&section_id=${sectionId}&academic_year=${academicYear}`,
};